import getApi from '../../api/apisauceConfig'
import { formatPatientStatisticsDates } from './mapper/patientStatistics.mapper'
import { Statistics } from '../../model/PatientStatistics'

export const getPatientStatistics = (patientId: number) =>
  getApi().get<Statistics[]>(`/patients/${patientId}/stat`).then(formatPatientStatisticsDates)
